<template>
  <div class="space">
    <div class="base-search">
      <el-button
        type="success"
        icon="el-icon-plus"
        @click="addEvent"
        style="background: #623AA2; border: none;"
      >
        新增
      </el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
      <el-input
        placeholder="请输入内容"
        v-model="pageVO.enterpriseName"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width:240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column type="index" width="150" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageVO.page - 1) * pageVO.pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="企业（团队）名称"
          align="center"
          prop="enterpriseName"
        ></el-table-column>
        <el-table-column label="入孵时间" align="center">
          <template slot-scope="scope">
            <span style="display:block;height:23px;overflow: hidden;">
              {{ GetTarg(scope.row.incubationDate) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="评估等级" align="center">
          <template slot-scope="scope">
            <el-rate disabled v-model="scope.row.starRating"></el-rate>
          </template>
        </el-table-column>
        <!-- <el-table-column label="logo" align="center" prop="hot">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.logoSrc" type="success" effect="plain">是</el-tag>
            <el-tag v-else type="danger" effect="plain">否</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="mini_btn"
              size="mini"
              type="primary"
              @click="handleAssess(scope.$index, scope.row)"
            >
              中期评估
            </el-button>
            <el-button
              class="mini_btn"
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              class="mini_btn"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="pageVO.page"
      :page-size="pageVO.pageSize"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>
    <el-dialog
      @closed="is_submit = true"
      :title="Title"
      center
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        v-if="dialogFormVisible"
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        :rules="siteFormRule"
      >
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="企业(团队)名称" prop="enterpriseName">
                <el-input
                  v-model="ruleForm.enterpriseName"
                  placeholder="请输入企业(团队)名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="企业性质" prop="institutionalNature">
                <el-select
                  style="width:100%"
                  v-model="ruleForm.institutionalNature"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="入孵时间" prop="incubationDate">
                <el-date-picker
                  v-model="ruleForm.incubationDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  style="text-align: left;width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="合同签订时间" prop="contractSignDate">
                <el-date-picker
                  v-model="ruleForm.contractSignDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  style="text-align: left;width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-row>
            <el-row></el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="ruleForm.logoSrc" :src="imgUrl + ruleForm.logoSrc" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logoSrc }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logoSrc">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logoSrc">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通讯地址" prop="postalAddressDistinguish">
            <v-distpicker
              style="text-align:left;"
              @selected="citySelected"
              :province="ruleForm.postalAddressEconomize"
              :city="ruleForm.postalAddressMarket"
              :area="ruleForm.postalAddressDistinguish"
            ></v-distpicker>
          </el-form-item>
          <el-form-item prop="detailedAddress">
            <el-input v-model="ruleForm.detailedAddress" placeholder="请填写详细地址"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="ruleForm.remark" placeholder="请填写备注信息"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="企业简介" prop="enterpriseIntroduce">
            <editor
              refName="introduction"
              :placeholderText="'请填写企业简介'"
              v-model="ruleForm.enterpriseIntroduce"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <el-dialog
      @closed="is_submit = true"
      title="中期评估"
      center
      :visible.sync="dialogFormAssess"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        v-if="dialogFormAssess"
        :model="assessForm"
        ref="assessForm"
        label-width="120px"
        :rules="assessFormRule"
        :disabled="disabledAssess"
      >
        <el-form-item label="评估等级" prop="starRating">
          <el-rate allow-half style="margin-top: 10px;" v-model="assessForm.starRating"></el-rate>
        </el-form-item>
        <el-form-item label="上传附件">
          <commonUpload
            @successUp="successUp"
            @removeUp="removeUp"
            :inputValue="'starRatingFile'"
            :txt="'上传附件材料'"
            :list="assessForm.starRatingFileList"
          ></commonUpload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!disabledAssess">
        <el-button @click="closeAssessForm('assessForm')">取 消</el-button>
        <el-button type="primary" @click="submitAssessForm('assessForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import commonUpload from '@/components/common-upload.vue';
import editor from "@/components/tinymce-editor/tinymce-editor";
export default {
	components: {
		editor,
		commonUpload
	},
	data() {
		var validateHoto = (rule, value, callback) => {
			if (this.ruleForm.hot == 1) {
				if (!value) {
					callback(new Error("请设置推荐度"));
				}
				if (!Number.isInteger(value)) {
					callback(new Error("请输入数字值"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
			pageVO:{
				enterpriseName:null,
				keyword:null,
				page:1,
				pageSize:10
			},
			is_submit: true,
			total: 0,
			Title: "",
			dialogFormVisible: false,
			dialogVisible: false,
			dialogFormAssess: false,
			disabledAssess: false,
			dialogImageUrl: "",
			deleteRow: [],
			fileList: [],
			tableData: [],
			levelOptions: [
       {
         value: 1,
         label: "事业单位",
       },
       {
         value: 2,
         label: "国有企业",
       },
       {
         value: 3,
         label: "民营企业",
       },
       {
         value: 4,
         label: "其他",
       },
     ],
			ruleForm: {
				enterpriseName: "",
				institutionalNature:"",
				incubationDate:"",
				contractSignDate:"",
				postalAddressEconomize:"甘肃省",
				postalAddressMarket:"兰州市",
				postalAddressDistinguish:"城关区",
				detailedAddress:"",
				remark:"",
				enterpriseIntroduce:"",
				logoSrc: ""
			},
			assessForm: {
				starRating: null,
				starRatingFile: null,
				starRatingFileList: []
			},
			siteFormRule: {
				enterpriseName:[
					{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }
				],
					logoSrc:[
						{
            required: true,
            message: '请上传logo',
            trigger: 'blur'
          }
				],
					contractSignDate:[
						{
            required: true,
            message: '请选择合同签订时间',
            trigger: 'blur'
          }
				],
					institutionalNature:[
						{
            required: true,
            message: '请选择企业性质',
            trigger: 'blur'
          }
				],
					incubationDate:[
						{
            required: true,
            message: '请选择入孵时间',
            trigger: 'blur'
          }
				],
					postalAddressDistinguish:[
						{
            required: true,
            message: '请选择通讯地址',
            trigger: 'blur'
          }
				],
			},
			assessFormRule: {
				starRating:[
					{
            required: true,
            message: '请选择评估等级',
            trigger: 'change'
          }
				],
			}
		};
	},
	created() {
		this.getData();
	},
	methods: {
		// release(row,type){
		//   let obj = {};
		//   obj.id = row.id;
		//   obj.type = 14;
		//   obj.hot = 1;
		// },
		getData() {
			this.http.post(this.urlConfig.devUrl+'apij2/admin-api/voucher/incubation-enterprise/page',this.pageVO).then(res =>{
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
				}
			})
		},
		//城市选择
		citySelected(e) {
			if(e.province.value){
			this.ruleForm.postalAddressEconomize = e.province.value
			}
			if(e.city.value){
			this.ruleForm.postalAddressMarket = e.city.value
			}
			if(e.area.value){
			this.ruleForm.postalAddressDistinguish = e.area.value
			}
		},
		//新增
		addEvent() {
			if (this.$refs["ruleForm"]) {
				this.$refs["ruleForm"].resetFields();
			}
			this.dialogFormVisible = true;
			this.Title = "新增";
			this.fileList = [];
			this.ruleForm = {
				enterpriseName: "",
				institutionalNature:"",
				incubationDate:"",
				contractSignDate:"",
				postalAddressEconomize:"甘肃省",
				postalAddressMarket:"兰州市",
				postalAddressDistinguish:"城关区",
				detailedAddress:"",
				remark:"",
				enterpriseIntroduce:"",
				logoSrc: ""
			};
		},
		//批量删除
		deleteAll() {
			if (this.deleteRow.length>0) {
				this.$confirm("此操作将批量删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http.post(this.urlConfig.devUrl+'apij2/admin-api/voucher/incubation-enterprise/deleteIds',{
							ids:this.deleteRow
						})
							.then((res) => {
								if (res.code == 0) {
									this.pageVO.page = 1
									this.getData();
									this.$message({
										type: "success",
										message: "删除成功",
									});

								} else {
									this.$message({
										message: "失败！",
										type: "error",
									});
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			} else {
				this.$message({
					type: "warning",
					message: "请选择删除的记录",
				});
			}
		},
		//搜索
		search() {
			this.pageVO.page =1
			this.pageVO.pageSize =10
			this.getData();
		},
		//翻页
    handleCurrentChange(val) {
      this.pageVO.page = val;
      this.getData();
    },
		//选择
		selectionChange(selection) {
			this.deleteRow = [];
			if (selection.length != 0) {
				let arr = [];
				selection.forEach((item) => {
					arr.push(item.id);
				});
				this.deleteRow = arr;
			}
		},
		// 评估
		handleAssess(index, row) {
			if(row.starRating){
				this.disabledAssess = true;
			} else {
				this.disabledAssess = false;
			}
			this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/voucher/incubation-enterprise/get/starRating?id=${row.id}`).then((res) => {
				if (res.code == 0) {
					this.assessForm = {
						...res.data
					}
					if (res.data.starRatingFile) {
						this.assessForm.starRatingFileList = JSON.parse(res.data.starRatingFile);
					} else {
						this.assessForm.starRatingFileList = [];
					}
					this.dialogFormAssess = true;
				}
			}).catch(err => {
				this.is_submit = true;
			});
		},
		//编辑
		handleEdit(index, row) {
			this.dialogFormVisible = true;
			this.Title = "编辑";
			row.detailed = row.address ? row.address.detailed : "";
			row.address = row.address ?
				row.address :
				{
					province: {
						value: ""
					},
					city: {
						value: ""
					},
					area: {
						value: ""
					}
				};
			this.ruleForm = JSON.parse(JSON.stringify(row));
			this.fileList = [];
			this.ruleForm.field = row.field.split(",");
			this.ruleForm.level = row.level.split(",");
			this.ruleForm.target = row.target.split(",");
			// this.ruleForm.detailed = row.address.detailed;
			if (row.image) {
				let arr = [];
				arr = row.image.split(",");
				arr.forEach((item, index) => {
					this.fileList.push({
						name: "download.jpg",
						url: this.imgUrl + item,
						store_result: item,
						uid: new Date().getTime() + index,
					});
				});
			}
		},
		//删除
		handleDelete(index, row) {
			this.$confirm("此操作将永久删除, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
				})
				.then(() => {
					this.http
						.request(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-enterprise/delete?id="+row.id, {
							id:row.id
						}, "delete")
						.then((res) => {
							if (res.code == 0) {
								this.pageVO.page = 1
								this.getData();
								this.$message({
									type: "success",
									message: "删除成功",
								});

							} else {
								this.$message({
									message: "失败！",
									type: "error",
								});
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		closeForm(name) {
			this.dialogFormVisible = false;
			this.$refs[name].resetFields();
		},
		closeAssessForm(name){
			this.dialogFormAssess = false;
			this.$refs[name].resetFields();
		},
		subData(name) {
			this.ruleForm.creatorName = JSON.parse(this.$store.getters.userInfo).name
			this.ruleForm.updateName = JSON.parse(this.$store.getters.userInfo).name
			if (!this.ruleForm.id) {
				this.http.post(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-enterprise/create", this.ruleForm).then((res) => {
					if (res.code == 0) {
						this.getData();
						this.$message({
							type: "success",
							message: "新增成功",
						});

						this.dialogFormVisible = false;
						this.$refs[name].resetFields();
					} else {
						this.is_submit = true;
					}
				}).catch(err => {
					this.is_submit = true;
				});
			}
			if (this.Title == "编辑") {
				this.http.put(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-enterprise/update", this.ruleForm).then((res) => {
					if (res.code == 0) {
						this.getData();
						this.$message({
							type: "success",
							message: "编辑成功",
						});
						this.dialogFormVisible = false;

						this.$refs[name].resetFields();
					} else {
						this.is_submit = true;
					}
				}).catch(err => {
					this.is_submit = true;
				});
			}
		},
		subDataAssess(name) {
			this.http.post(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-enterprise/create/starRating", this.assessForm).then((res) => {
					if (res.code == 0) {
						this.getData();
						this.$message({
							type: "success",
							message: "新增成功",
						});

						this.dialogFormAssess = false;
						this.$refs[name].resetFields();
					} else {
						this.is_submit = true;
					}
				}).catch(err => {
					this.is_submit = true;
				});
		},
		//提交
		submitForm(name) {
			this.$refs[name].validate((valid) => {
				if (valid) {
					this.subData(name);
				} else {
					return false;
				}
			});
		},
		submitAssessForm(name) {
			this.$refs[name].validate((valid) => {
				if (valid) {
					this.subDataAssess(name);
				} else {
					return false;
				}
			});
		},
		handlePictureCardPreview(file) {
			console.log(file);
			// this.ruleForm.logoSrc = file;
			this.ruleForm.logoSrc = file.data.store_result;
		},
		beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 10;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 10MB!");
			}
			return type && isLt2M;
		},
		deleteImg() {
			this.$confirm("确定删除图片吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
				})
				.then(() => {
					this.ruleForm.logoSrc = "";
					this.$message({
						type: "success",
						message: "删除成功!",
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		successUp(name, val) {
      this.changeFileList(name, val);
    },
    removeUp(name, val) {
      this.changeFileList(name, val);
    },
		changeFileList(name, val) {
			this.assessForm[name+'List'] = this.getList(val);
			this.assessForm[name] = JSON.stringify(this.assessForm[name+'List'])
		},
		getList(fileList) {
      return fileList.map(el => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid
        };
      });
    }
	},
};
</script>

<style scoped lang="scss">
.space {
  height: 100%;
  width: 100%;

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-select {
      margin: 0 15px;
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}

/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}
.upload-demo {
  margin-top: 0;
  border: none;
  /deep/ .el-upload {
    border: none !important;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
</style>
